"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.275 6.635a.883.883 0 0 0-.875.89v4.949c0 .498.398.89.875.89h5.512a.883.883 0 0 0 .875-.89V7.526a.88.88 0 0 0-.875-.89zm7.788 1.119v-.228a2.28 2.28 0 0 0-2.276-2.29H5.276A2.28 2.28 0 0 0 3 7.525v4.948a2.28 2.28 0 0 0 2.275 2.29h5.512a2.28 2.28 0 0 0 2.275-2.29v-.228l1.515 1.231c.984.8 2.423.081 2.423-1.162v-4.63c0-1.244-1.439-1.962-2.422-1.163zm0 1.804v.884l2.397 1.949c.021.017.035.02.043.02q.017.003.045-.009a.1.1 0 0 0 .038-.033.1.1 0 0 0 .014-.054v-4.63a.1.1 0 0 0-.014-.055.1.1 0 0 0-.038-.032.1.1 0 0 0-.045-.01.081.081 0 0 0-.042.02z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VideoIcon20.js.map